import { MenuItem, MenuItemProps, Text } from "@chakra-ui/react";

export type Props = {
  title: React.ReactNode;
  description: React.ReactNode;
} & MenuItemProps;
export const MenuItemWithDescription: React.FC<Props> = ({
  title,
  description,
  children,
  ...props
}) => {
  return (
    <MenuItem
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      paddingX="4"
      paddingY="2"
      {...props}
    >
      <Text fontSize="1rem" color="gray.900">
        {title}
      </Text>
      <Text color="blackAlpha.700" fontSize="sm">
        {description}
      </Text>
      {children}
    </MenuItem>
  );
};
